/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'SignIn': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M6.172 10.601l3.102-3.102-3.102-3.103M1 7.5h8.273" _stroke="#00204D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M8.094 1h5.318a.59.59 0 01.59.59v11.82a.59.59 0 01-.59.59H8.094" _stroke="#00204D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
